'use client';

import React, { useState, useMemo } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { teachers as teachersData } from '@/db/teachersData';

interface TeacherSectionProps {
  teacherId?: number;
}

const TeacherSection: React.FC<TeacherSectionProps> = ({ teacherId }) => {
  const [searchQuery, setSearchQuery] = useState('');

  // Find the active teacher based on teacherId
  // Fallback to the first teacher if none provided or id doesn't match
  const activeTeacher = useMemo(() => {
    if (teacherId) {
      return teachersData.find(t => t.id === teacherId) || teachersData[0];
    }
    return teachersData[0];
  }, [teacherId]);

  // Other teachers list (excluding the current one)
  const otherTeachers = useMemo(() => {
    return teachersData.filter(t => t.id !== activeTeacher.id);
  }, [activeTeacher.id]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
  };

  const filteredTeachers = otherTeachers.filter(teacher =>
    teacher.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    teacher.role.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <section className="single-teacher-area">
      <div className="container">
        <div className="row">
          {/* Main Teacher Details */}
          <div className="col-lg-8 col-md-7">
            <div className="teacher-slider">
              <div className="single-slider">
                <div className="teacher-img teacher-detail-img">
                  <Image
                    src={activeTeacher.image}
                    alt={activeTeacher.name}
                    width={400}
                    height={400}
                    priority

                  />
                </div>
                <div className="content">
                  <h2>{activeTeacher.name} ({activeTeacher.role})</h2>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.
                  </p>
                  <p>
                    {activeTeacher.name} is a dedicated professional at Cayman Academy, committed to providing high-quality education and support to our students. With expertise in their field, they play a vital role in our academic community.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Sidebar */}
          <div className="col-lg-4 col-md-5">
            <div className="right-content">
              {/* Search Form */}
              <form onSubmit={handleSearch}>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control about-search"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>
                <button type="submit" className="search-btn">
                  <i className="fa-solid fa-magnifying-glass"></i>
                </button>
              </form>

              {/* Other Teachers Section */}
              <p className="visit">Other Teachers</p>

              <div className="teachers-list">
                {filteredTeachers.slice(0, 8).map((teacher) => (
                  <div key={teacher.id} className="single-teacher">
                    <div className="row align-items-center">
                      <div className="col-3 col-md-4">
                        <div className="other-teacher-img">
                          <Image
                            src={teacher.image}
                            alt={teacher.name}
                            width={80}
                            height={80}
                            style={{ objectFit: 'cover', borderRadius: '5px' }}
                          />
                        </div>
                      </div>
                      <div className="col-9 col-md-8">
                        <div className="content">
                          <Link href={`/teacher?id=${teacher.id}`}>
                            <h2>{teacher.name}</h2>
                            <p>{teacher.role}</p>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* More Teachers Button */}
              <Link href="/teachers" className="box-btn">
                More Teachers
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeacherSection;
